import { storeToRefs } from 'pinia'
import { watch } from 'vue'
import { useConfiguration } from '../model'

export const useReloadOnConfigurationUpdate = (handler: () => void | Promise<void>) => {
  const { appUpdateKey } = storeToRefs(useConfiguration())

  watch(appUpdateKey, () => {
    void handler()
  })
}
